// extracted by mini-css-extract-plugin
module.exports = {"loadGame":"LoadElement_loadGame__2DwTr","loadGame_body":"LoadElement_loadGame_body__1JhC3"};